/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Tabs_StorageInputs */

const en_admin_settings_tabs_storage = /** @type {(inputs: Admin_Settings_Tabs_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storage`)
};

/**
* | output |
* | --- |
* | "Storage" |
*
* @param {Admin_Settings_Tabs_StorageInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_tabs_storage = /** @type {((inputs?: Admin_Settings_Tabs_StorageInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Tabs_StorageInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_tabs_storage(inputs)
});
export { admin_settings_tabs_storage as "admin.settings.tabs.storage" }